import React, { useEffect, useState, useContext } from "react";
import LayoutDashboard from "../../Components/Layout/LayoutDashboard";
import AuthContext from "../../Context/autenticacion/authContext";
import ComponentsBarcode from "./ComponentsBarcode";
import ComponentsTypeSaleClient from "./ComponentsTypesaleClient";
import ProductInfo from "../Sales/ProductInfo";
import ProductsList from "../Sales/ProductsList";
import Button from "@material-ui/core/Button";
import MethodGet from "../../Config/Services";
import headerConfig from "../../Config/imageHeaders";
import { Grid, Paper, Box, Chip } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Swal from "sweetalert2";
import { MethodPost } from "../../Config/Services";
import fileDownload from "js-file-download";
import clienteAxios from "../../Config/Axios";
import { toast } from "react-toastify";
import ErrorIcon from "@material-ui/icons/Error";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import StorefrontIcon from "@material-ui/icons/Storefront";
import "react-toastify/dist/ReactToastify.css";
import ModalPaymentMethod from "./ModalPaymentMethod";
import "./Product.css";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  mainContainer: {
    padding: "0 16px",
    [theme.breakpoints.down("sm")]: {
      padding: "0 8px",
    },
  },
}));

function SalesAddProduct(props) {
  //excel
  const [productsExcel, saveproductsExcel] = useState([]);

  const classes = useStyles();
  const [productoID, guardarProductoID] = useState("");
  const [clienteID, guardarClienteID] = useState("");
  const [subtotal, guardarTotal] = useState(0);
  const [subtotalBrand, SaveSubTotalBrand] = useState(0);
  const [subtotalWithoutBrand, SaveSubTotalWithoutBrand] = useState(0);
  const [subtotalSPA, saveSubTotalSPA] = useState(0);
  const [totalDescuento, guardarTotalDescuento] = useState(0);
  const [totalDiscountBrand, saveTotalDiscountBrand] = useState(0);
  const [totalDiscountWithoutBrand, saveTotalDiscountWithoutBrand] =
    useState(0);
  const [totalDiscountSPA, saveTotalDiscountSPA] = useState(0);
  const [disableButton, setDisabledButton] = useState(false);
  const [comission, saveComission] = useState(0);

  const [cliente, saveCliente] = useState("");

  const [image, setImage] = useState({
    urlPhoto: "https://pisouniversitario.com/template/images/page-404.jpg",
    image: "",
  });

  const [imageTransfer, setImageTransfer] = useState({
    urlPhoto: "https://pisouniversitario.com/template/images/page-404.jpg",
    image: "",
  });

  const [open, setOpen] = useState(false);
  const [descuentoporcentaje, guardarDescuento] = useState({});
  const [discountWithoutBrand, saveDiscountWithoutBrand] = useState({});
  const [discountSPA, saveDiscountSPA] = useState({});

  const [value, setValue] = useState(0);

  //TIPOS DE PRODUCTOS
  const [productsBranded, saveProductsBranded] = useState([]);
  const [productsWithoutBrand, saveProductsWithoutBrand] = useState([]);
  const [productsSPA, saveProductsSPA] = useState([]);

  useEffect(() => {
    let totalSubTotal =
      Number(subtotalBrand) +
      Number(subtotalWithoutBrand) +
      Number(subtotalSPA);
    guardarTotal(totalSubTotal);
  }, [subtotalBrand, subtotalWithoutBrand, subtotalSPA]);

  const [informacionMetodoPago, guardarMetodoPago] = useState({
    amount: "0",
    change: "0",
    cash_income: "0",
    card_income: "0",
    transfer_income: "0",
  });
  const { id } = props;
  //Extraer la informacion de autenticación
  const authContext = useContext(AuthContext);
  const { usuario } = authContext;

  const [typeProduct, saveTypeProduct] = useState();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    guardarMetodoPago({
      amount: 0,
      change: 0,
      cash_income: 0,
      card_income: 0,
      transfer_income: 0,
    });
    setOpen(false);
  };

  const [branch, guardarBranch] = useState({});
  const [couponInfo, saveCouponInfo] = useState("");

  const [type_sale, saveTypeSale] = useState("");
  const [business_rule, saveBussinesRule] = useState("");

  const obtenerInformacionPago = (e) => {
    guardarMetodoPago({
      ...informacionMetodoPago,
      [e.target.name]: e.target.value,
    });
  };

  const detectarCambiosTypeSale = (value) => {
    saveTypeSale(value.value);
  };
  const productsOnLocal = localStorage.getItem("EnterProducts")
  const [productsList2, saveproductslist] = useState(
    productsOnLocal ? JSON.parse(productsOnLocal) : []
  );
  useEffect(() => {
    saveProductsBranded(productsList2);
  }, [productsList2]);
  //Extraer valores de branch(destructuracion)
  const { name } = branch;
  //obtener los campos de la sucursal
  useEffect(() => {
    let url = `/branches/${id}`;
    MethodGet(url)
      .then((res) => {
        guardarBranch(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const [gtotal, saveTotal] = useState([]);

  const [error, guardarError] = useState(true);
  useEffect(() => {
    const getotals = async () => {
      await clienteAxios
        .get(`branchUtility/${id}`)
        .then((res) => {
          saveTotal(res.data);
        })
        .catch((error) => {
          console.log(error);
        });

      if (props.course) {
        guardarError(false);
      }
    };
    getotals();
  }, []);
  useEffect(() => {
    const ConsultaAPI = () => {
      if (clienteID && business_rule) {
        let urlclient = `/clientsforRule/${clienteID}`;
        MethodGet(urlclient).then((response) => {
          saveCliente(response.data.client);
        });
        let url = `/discountforRule/${business_rule}`;
        MethodGet(url).then((response) => {
          guardarDescuento(response.data);
        });
      }
    };

    ConsultaAPI();
  }, [clienteID, type_sale, business_rule]);

  //funcion para guardar la imagen y obtener la vista previa
  const handleChangeImage = (e) => {
    setImage({
      ...image,
      urlPhoto: URL.createObjectURL(e.target.files[0]),
      image: e.target.files[0],
    });
  };

  //funcion para guardar la imagen y obtener la vista previa
  const handleChangeImageTransfer = (e) => {
    setImageTransfer({
      ...imageTransfer,
      urlPhoto: URL.createObjectURL(e.target.files[0]),
      image: e.target.files[0],
    });
  };

  useEffect(() => {
    let totalSale =
      Number(totalDiscountBrand) +
      Number(totalDiscountWithoutBrand) +
      Number(totalDiscountSPA);
    let descuentoPorcentajeNew = 0;
    if (cliente) {
      guardarTotalDescuento(Math.round(totalSale));
    }
  }, [
    totalDiscountBrand,
    totalDiscountWithoutBrand,
    totalDiscountSPA,
    descuentoporcentaje,
    cliente,
  ]);

  const generarVenta = (e) => {
    e.preventDefault();
    if (
      totalDescuento < informacionMetodoPago.amount &&
      informacionMetodoPago.cash_income < totalDescuento
    ) {
      toast.warn(
        <div>
          <ErrorIcon /> No puedes pagar mas del monto total
        </div>,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      return;
    } else if (informacionMetodoPago.amount < 0) {
      toast.warn(
        <div>
          <ErrorIcon /> No puedes ingresar valores negativos
        </div>,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      return;
    } else if (informacionMetodoPago.card_income > 0) {
      if (image.image == "") {
        toast.warn(
          <div>
            <ErrorIcon /> Debes seleccionar la imagen del ticket de pago por
            tarjeta
          </div>,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        return;
      }
    }
    setDisabledButton(true);

    var products_list_branded = JSON.stringify(productsBranded);
    var products_list_withoutBrand = JSON.stringify(productsWithoutBrand);
    var products_list_SPA = JSON.stringify(productsSPA);

    const formData = new FormData();
    formData.append("client_id", clienteID);
    formData.append("user_id", usuario.id);

    formData.append("total", totalDescuento);
    formData.append("totalDiscountBrand", totalDiscountBrand);
    formData.append("totalDiscountWithoutBrand", totalDiscountWithoutBrand);
    formData.append("totalDiscountSPA", totalDiscountSPA);

    formData.append("subtotal", subtotal);
    formData.append("subtotalBrand", subtotalBrand);
    formData.append("subtotalWithoutBrand", subtotalWithoutBrand);
    formData.append("subtotalSPA", subtotalSPA);
    formData.append("previous_balance", gtotal.last_current_balance);

    formData.append("products_list_branded", products_list_branded);
    formData.append("products_list_withoutBrand", products_list_withoutBrand);
    formData.append("products_list_SPA", products_list_SPA);
    formData.append("card_income", informacionMetodoPago.card_income);
    formData.append("cash_income", informacionMetodoPago.cash_income);
    formData.append("transfer_income", informacionMetodoPago.transfer_income);
    if (couponInfo != "") {
      formData.append("coupon_id", couponInfo.id);
    }
    if (informacionMetodoPago.card_income > 0) {
      formData.append("image", image.image);
      formData.append("comission", comission);
    }
    if (informacionMetodoPago.transfer_income > 0) {
      formData.append("reference", informacionMetodoPago.reference);
      formData.append("imageTransfer", imageTransfer.image);
    }
    if (
      informacionMetodoPago.cash_income > 0 &&
      informacionMetodoPago.cash_income > totalDescuento
    ) {
      formData.append("change", informacionMetodoPago.change);
    }

    if (totalDiscountBrand != subtotalBrand) {
      formData.append("discount", descuentoporcentaje.discount);
    }
    if (totalDiscountWithoutBrand != subtotalWithoutBrand) {
      formData.append("discountWithoutBrand", discountWithoutBrand.discount);
    }
    if (totalDiscountSPA != subtotalSPA) {
      formData.append("discountSPA", discountSPA.discount);
    }

    let url = "/sales";
    MethodPost(url, formData, { headerConfig })
      .then((res) => {
        let id = res.data.data.id;
        let branchid = res.data.data.branch_office_id;
        let folio = res.data.data.folio;
        let timerInterval;
        Swal.fire({
          title: "Generando",
          html: "El ticket se esta generando",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          willClose: () => {
            clearInterval(timerInterval);
          },
        }).then((result) => {
          //Cunsume API de Back-end en laravel para generar tiket de venta
          clienteAxios
            .get(`/ticket/${id}`, { responseType: "blob" })
            .then((response) => {
              let pdfname = "TicketFolio" + folio + ".pdf";
              let nombrepdf = "ticket.pdf";
              let nombrePrint = "POS-80";
              let url2 = `http://localhost:8080/?nombrePdf=${pdfname}&impresora=${nombrePrint}`;

              fileDownload(response.data, pdfname);
              Swal.fire({
                title: "Buen trabajo",
                text: "Venta registrada exitosamente",
                icon: "success",
                timer: 3000,
                showConfirmButton: false,
              });
              // setTimeout(() => {
              //   fetch(url2);
              // }, "1000");
            })
            .catch((error) => {
              if (error.response.status === 409) {
                Swal.fire({
                  icon: "error",
                  title: "Algo sucedio",
                  text: "No se cuenta con suficiente información para generar el reporte",
                });
                return;
              } else if (error.response.status === 422) {
                console.log(error);
                return;
              }
              return;
            });
        });
        localStorage.removeItem("EnterProducts")
        props.history.push(`/SucursalVentas/${branchid}`);
      })
      .catch((error) => {
        if (error.response.data.error) {
          setOpen(false);
          setDisabledButton(false);
          toast.error(
            <div>
              <ErrorIcon /> {error.response.data.error}{" "}
            </div>,
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            }
          );
          guardarMetodoPago({
            amount: 0,
            change: 0,
            cash_income: 0,
            card_income: 0,
            transfer_income: 0,
          });
          return;
        } else {
          setDisabledButton(false);
          toast.error(
            <div>
              <ErrorIcon /> Error inesperado. Si persiste, contacta con el
              administrador{" "}
            </div>,
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            }
          );
          return;
        }
        return;
      });
  };

  // Formatted totals for summary panel
  const fmtCurrency = (val) =>
    new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency: "MXN",
      minimumFractionDigits: 2,
    }).format(isNaN(val) ? 0 : val);

  return (
    <LayoutDashboard>
      {/* ── HEADER ── */}
      <div className="sale-header">
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <StorefrontIcon style={{ fontSize: 28, opacity: 0.8 }} />
          <h4>Nueva Venta</h4>
        </div>
        <span className="branch-chip">{name || "Sucursal"}</span>
      </div>

      {/* ── MAIN 2-COLUMN LAYOUT ── */}
      <Grid container spacing={2} className={classes.mainContainer}>
        {/* ── LEFT COLUMN: Config + Products ── */}
        <Grid item xs={12} md={8}>
          {/* Config Card */}
          <div className="config-card">
            <div className="config-title">Configuración de venta</div>
            <ComponentsTypeSaleClient
              clienteID={clienteID}
              guardarClienteID={guardarClienteID}
              id={id}
              saveProductsBranded={saveProductsBranded}
              typeProduct={typeProduct}
              type_sale={type_sale}
              detectarCambiosTypeSale={detectarCambiosTypeSale}
            />
            <div style={{ marginTop: 12 }}>
              <ComponentsBarcode
                saveBussinesRule={saveBussinesRule}
                saveTypeProduct={saveTypeProduct}
                typeProduct={typeProduct}
                guardarProductoID={guardarProductoID}
                clienteID={clienteID}
                guardarClienteID={guardarClienteID}
                id={id}
                saveProductsWithoutBrand={saveProductsWithoutBrand}
                saveProductsBranded={saveProductsBranded}
                saveProductsSPA={saveProductsSPA}
                productsBranded={productsBranded}
                productsWithoutBrand={productsWithoutBrand}
                productsSPA={productsSPA}
                type_sale={type_sale}
                detectarCambiosTypeSale={detectarCambiosTypeSale}
              />
            </div>
            {/* ProductInfo (add button for select mode) */}
            <ProductInfo
              productoID={productoID.value}
              clienteID={clienteID}
              saveProductsWithoutBrand={saveProductsWithoutBrand}
              saveProductsBranded={saveProductsBranded}
              saveProductsSPA={saveProductsSPA}
              productsWithoutBrand={productsWithoutBrand}
              productsSPA={productsSPA}
              productsBranded={productsBranded}
              guardarProductoID={guardarProductoID}
              typeProduct={typeProduct}
              setValue={setValue}
              value={0}
            />
          </div>

          {/* Products Table Card */}
          <div className="products-card">
            <div className="products-card-header">
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <ShoppingCartIcon style={{ color: "#3f51b5", fontSize: 20 }} />
                <h6>Productos en venta</h6>
              </div>
              <span className="badge">
                {productsBranded.length + productsWithoutBrand.length + productsSPA.length} items
              </span>
            </div>
            <ProductsList
              productsExcel={productsExcel}
              saveProductsWithoutBrand={saveProductsWithoutBrand}
              saveProductsBranded={saveProductsBranded}
              saveProductsSPA={saveProductsSPA}
              productsBranded={productsBranded}
              productsWithoutBrand={productsWithoutBrand}
              productsSPA={productsSPA}
              id={id}
              subtotalBrand={subtotalBrand}
              SaveSubTotalBrand={SaveSubTotalBrand}
              subtotalWithoutBrand={subtotalWithoutBrand}
              subtotalSPA={subtotalSPA}
              saveSubTotalSPA={saveSubTotalSPA}
              SaveSubTotalWithoutBrand={SaveSubTotalWithoutBrand}
              totalDescuento={totalDescuento}
              descuentoporcentaje={descuentoporcentaje}
              discountWithoutBrand={discountWithoutBrand}
              discountSPA={discountSPA}
              totalDiscountBrand={totalDiscountBrand}
              saveTotalDiscountBrand={saveTotalDiscountBrand}
              totalDiscountWithoutBrand={totalDiscountWithoutBrand}
              saveTotalDiscountWithoutBrand={saveTotalDiscountWithoutBrand}
              totalDiscountSPA={totalDiscountSPA}
              saveTotalDiscountSPA={saveTotalDiscountSPA}
              subtotal={subtotal}
              cliente={cliente}
              setValue={setValue}
              value={0}
            />
          </div>
        </Grid>

        {/* ── RIGHT COLUMN: Summary + Checkout ── */}
        <Grid item xs={12} md={4}>
          <div className="summary-panel">
            {/* Summary Card */}
            <div className="summary-card">
              <div className="summary-header">
                <h6>Total a pagar</h6>
                <div className="total-amount">
                  {fmtCurrency(totalDescuento)}
                </div>
              </div>
              <div className="summary-body">
                <div className="summary-row">
                  <span className="label">Subtotal</span>
                  <span className="value">{fmtCurrency(subtotal)}</span>
                </div>
                <div className="summary-row discount">
                  <span className="label">Descuento</span>
                  <span className="value">
                    {Object.keys(descuentoporcentaje).length
                      ? `${descuentoporcentaje.discount}%`
                      : "—"}
                  </span>
                </div>
                <div className="summary-row">
                  <span className="label">Total</span>
                  <span className="value" style={{ fontSize: "1.1rem", color: "#1a237e" }}>
                    {fmtCurrency(totalDescuento)}
                  </span>
                </div>

                {/* Checkout Button */}
                {subtotal > 0 ? (
                  <Button
                    className="checkout-btn"
                    variant="contained"
                    onClick={handleClickOpen}
                    startIcon={<ShoppingCartIcon />}
                  >
                    Cobrar Venta
                  </Button>
                ) : (
                  <Button
                    className="checkout-btn"
                    variant="contained"
                    disabled
                  >
                    Agrega productos para continuar
                  </Button>
                )}
              </div>
            </div>
          </div>
        </Grid>
      </Grid>

      {/* ── Payment Modal ── */}
      <ModalPaymentMethod
        open={open}
        branch={branch}
        saveCouponInfo={saveCouponInfo}
        couponInfo={couponInfo}
        setOpen={setOpen}
        handleClickOpen={handleClickOpen}
        handleClose={handleClose}
        totalDescuento={totalDescuento}
        subtotal={subtotal}
        guardarTotalDescuento={guardarTotalDescuento}
        informacionMetodoPago={informacionMetodoPago}
        image={image}
        imageTransfer={imageTransfer}
        comission={comission}
        saveComission={saveComission}
        clienteID={clienteID}
        obtenerInformacionPago={obtenerInformacionPago}
        generarVenta={generarVenta}
        handleChangeImage={handleChangeImage}
        handleChangeImageTransfer={handleChangeImageTransfer}
        disableButton={disableButton}
      />
    </LayoutDashboard>
  );
}

export default SalesAddProduct;
